import React, { useContext, useEffect, useState } from 'react';
import { Message } from 'semantic-ui-react';
import UserContext from '../../../contexts/UserContext';
import { listFacilityQuestions } from '../../services/Survey';
import { FacilityQuestion } from '../../types/Survey';
import sendToast from '../../../utils/Toast';
import SurveyQuestions from '../../components/SurveyQuestions';

const Survey = () => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const activeRegistrantIndex = activeRegistrantsIndexes[0];
    const activeResident = typeof activeRegistrantIndex === 'number' ? listOfResidents[activeRegistrantIndex] : undefined;
    const activeFacilityId = activeResident?.Facility;
    const [questions, setQuestions] = useState<FacilityQuestion[]>([]);
    // Start in the loading state when a fetch is about to run, so the empty state doesn't flash first.
    const [loading, setLoading] = useState<boolean>(Boolean(activeFacilityId));

    useEffect(() => {
        getSurveyQuestions();
    }, [activeFacilityId]);

    const getSurveyQuestions = async () => {
        if (!activeFacilityId) return;
        setLoading(true);
        try {
            const result = await listFacilityQuestions(activeFacilityId);
            setQuestions(result);
        } catch (error) {
            sendToast('error', error instanceof Error ? error.message : 'Failed to fetch survey questions');
        } finally {
            setLoading(false);
        }
    };

    if (!activeResident) {
        return <Message content="Invalid user. Please contact support." />;
    }

    return (
        <SurveyQuestions
            questions={questions}
            loading={loading}
            facilityId={activeResident.Facility}
            residentId={String(activeResident._id)}
        />
    );
};

export default Survey;
